import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {IEmail} from '../../shared/model/interface/email.model.interface';
import {IVerifyEmailResponseList} from "../../shared/model/interface/iverify-email-response";

@Injectable({
  providedIn: 'root'
})
export class CustomerEmailService {
  private static readonly _URL = environment.backendUrl + '/customers';

  constructor(private httpClient: HttpClient) {
  }

  create(customerId: number, email: string) {
    return this.httpClient.post<IEmail>(CustomerEmailService._URL + `/${customerId}/emails/create`, email);
  }

  delete(emailId: number) {
    return this.httpClient.delete(CustomerEmailService._URL + `/emails/${emailId}/delete`);
  }

  edit(emailId: number, email: string) {
    return this.httpClient.put(CustomerEmailService._URL + `/emails/${emailId}/edit`, email);
  }

  verify(emails: string[]) {
    return this.httpClient.post<IVerifyEmailResponseList>(CustomerEmailService._URL + `/emails/verify`, emails);
  }
}
